import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const updateContact = async ({ data, contactId }: any) => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/contacts/${contactId}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const contact = await result.json();
  return contact;
};

export default updateContact;
